<template>
  <div class="home">
    <div class="Navbar">
      <div class="g-header">
        <div class="navleft">
          <img src="@/assets/image/logo.png" class="nav-logo" alt="logo" />
          <!-- ✅ 已隐藏：左上角线路1/线路2 -->
        </div>
        <div class="middle fs-18"></div>
        <div class="navright" @click="changeLanguage">
          <span>{{ texType == 0 ? $t("gensuixitong") : $t("jiantizhongwen") }} </span>
        </div>
      </div>
      <div class="block"></div>
    </div>
    <div class="g-content flex-column">
      <div class="mescroll">
        <!-- 轮播 -->
        <swi-pe></swi-pe>
        <div class="broadcast">
  <van-notice-bar
    class="home-notice"
    :text="homeNoticeText"
    :scrollable="homeNoticeScrollable"
    :wrapable="!homeNoticeScrollable"
    background="transparent"
    color="#a0a0a0"
  >
    <template #left-icon>
      <div class="broadcast-icon">
        <div class="sprite-icon_gonggao"></div>
      </div>
    </template>
  </van-notice-bar>
</div>
        <!-- 横向滑动 -->
        <lt-list></lt-list>
        <!-- 资产 -->
        <div class="cont-head">
          <div class="cont-left">
            <div>
              <div class="en-text">{{ $t("wodezichan") }}</div>
              <div class="left-text">
                {{ money ? money : $t("dengluhouchakan") }}
              </div>
            </div>
            <img src="@/assets/image/zichan.png" class="icon" alt="" />
          </div>
          <div class="cont-right" @click="changeNews">
            <div class="huobin">
              <img src="@/assets/image/touzi.png" class="rightcion" alt="" />
              <div>{{ $t("touzikuaixun") }}</div>
            </div>
          </div>
        </div>
        <!---横线块无颜色 -->
        <div class="menu-container"></div>
        <!-- 跑马灯 -->
        <div class="prize-news-wrap">
          <div class="sub-title">
            <span>{{ $t("jiaoyiyonghu") }}</span>
            <span>{{ $t("jiaoyipinglei") }}</span>
            <span>{{ $t("danlunhuoli") }}</span>
            <span>{{ $t("jiaoyiriqi") }}</span>
          </div>
          <div class="prize-news">
            <!-- 修复：简化逻辑，直接使用v-if，在数据加载后延迟渲染 -->
            <vue-seamless-scroll
              v-if="infoList && infoList.length > 0"
              :key="`scroll-${scrollKey}`"
              ref="scrollComponent"
              class="vux-marquee prize-marquee"
              :class-option="classOption"
              :data="infoList"
            >
              <ul class="vux-marquee-box">
                <li
                  class="prize-marquee-item"
                  v-for="(item, index) in infoList"
                  :key="index"
                >
                  <span class="name">{{ item.nickname }}</span>
                  <!-- ✅ 交易品类：优先显示购入类型 play_method；没有就回退 game_name -->
                  <span class="type">{{ item.play_method ? $t(item.play_method) : (item.game_name || '') }}</span>
                  <span class="money">{{ item.profit }}</span>
                  <span class="date">{{ time }}</span>
                </li>
              </ul>
            </vue-seamless-scroll>
            <!-- 修复：无数据时显示提示 -->
            <div v-else class="no-data-tip">{{ $t('wuTps') || '暂无数据' }}</div>
          </div>
        </div>
      </div>
    </div>
    <tab-bar></tab-bar>

    <!-- ✅ 已删除：线路遮罩层（避免左上角出现“线路1/2”） -->
  </div>
</template>

<script>
// @ is an alias to /src
import TabBar from "@/components/tabbar/TabBar.vue";
import LtList from "@/components/ltlist/LtList.vue";
import SwiPe from "@/components/swipe/SwiPe.vue";
import homeApi from "@/api/home";
import vueSeamlessScroll from "vue-seamless-scroll/src";

export default {
  name: "Home",
  components: {
    TabBar,
    SwiPe,
    LtList,
    vueSeamlessScroll,
  },
  computed: {
    classOption() {
      return {
        step: 1, // 修复：增加滚动速度，0.2太慢可能看起来像没滚动
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
        limitMoveNum: 5, // 修复：限制滚动区域内的数据量，确保有足够内容滚动
      };
    },
    money() {
      return this.$store.state.money;
    },
  },
  data() {
    return {
      infoList: [],
      isShow: true,
      texType: localStorage.getItem("localetype"),
      time: "",
      homeNoticeText: "暂无公告",
      homeNoticeScrollable: true,
      scrollKey: 0,  // 修复：用于强制刷新滚动组件
    };
  },
  methods: {
    changeLanguage() {
      this.$router.push({
        path: "/language",
      });
    },
    fetchHomeNotice() {
      homeApi
        .homeNotice()
        .then((data) => {
          const d = (data && data.data) ? data.data : {};
          if (d.text !== undefined && d.text !== null && String(d.text).trim() !== "") {
            this.homeNoticeText = d.text;
          }
          if (d.scroll !== undefined && d.scroll !== null && d.scroll !== "") {
            this.homeNoticeScrollable = Number(d.scroll) === 1;
          }
        })
        .catch(() => {
          // 接口失败时保留默认“暂无公告”
        });
    },
    info() {
      this.$toast.loading({
        message: this.$t("jiazaizhong"),
        forbidClick: true,
        duration: 0,
      });
      homeApi
        .heart("", "")
        .then((data) => {
          // 修复：确保 hit_notice 是数组格式，避免滚动组件失效
          const newList = Array.isArray(data.data?.hit_notice) 
            ? data.data.hit_notice 
            : [];
          
          // 修复：更新数据后，延迟更新key以强制刷新滚动组件
          this.infoList = newList;
          
          // 修复：使用双重nextTick + setTimeout确保DOM完全渲染后再刷新组件
          if (newList.length > 0) {
            // 先更新key，让组件重新渲染
            this.scrollKey = Date.now();
            // 然后确保组件正确初始化
            this.$nextTick(() => {
              setTimeout(() => {
                // 再次更新key，强制刷新
                this.scrollKey = Date.now();
                // 尝试调用组件的更新方法（如果组件支持）
                if (this.$refs.scrollComponent && this.$refs.scrollComponent.updateScroll) {
                  this.$refs.scrollComponent.updateScroll();
                }
              }, 300);  // 300ms延迟确保DOM完全渲染
            });
          }
          
          this.$toast.clear();
        })
        .catch((err) => {
          // 修复：错误时也设置为空数组，避免undefined导致滚动失效
          this.infoList = [];
          this.$toast.fail(err);
        });
    },
    changeNews() {
      this.$router.push({
        path: "/moreNews",
      });
    },
  },
  created() {
    let myDate = new Date();
    let t = myDate.toLocaleDateString();
    this.time = t.slice(5);
    this.fetchHomeNotice();
    // 修复：延迟加载数据，确保组件已挂载
    this.$nextTick(() => {
      this.info();
    });
  },
  mounted() {
    // 修复：在mounted阶段，如果数据已加载，初始化滚动组件
    if (this.infoList && this.infoList.length > 0) {
      this.$nextTick(() => {
        setTimeout(() => {
          this.scrollKey = Date.now();  // 初始化key
        }, 300);  // 300ms延迟确保DOM完全渲染
      });
    }
  },
};
</script>

<style lang="less" scoped>
.home {
  height: 100%;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
}
.g-header {
  position: absolute;
  width: 100%;
  height: 1.18rem;
  text-align: center;
  background: rgb(14, 21, 48);
  z-index: 9999;
  font-size: 0.35rem;
  color: #fff;
}
.block {
  height: 1.18rem;
}
.navleft,
.navright {
  display: flex;
  z-index: 11;
  position: absolute;
  height: 100%;
  align-items: center;
}
.middle {
  z-index: 10;
  max-width: 80%;
  text-align: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.fs-18 {
  font-size: 0.36rem;
}
.navright {
  right: 0.2rem;
}

.navleft {
  left: 0.2rem;
}

.nav-logo {
  width: 0.7rem;
  height: 0.7rem;
  object-fit: contain;
}

.home-notice {
  width: 100%;
  padding: 0;
}

.broadcast {
  min-height: 30px;
  padding: 0.2rem 0.4rem;
  display: flex;
  align-items: center;
}
.broadcast-icon {
  margin-right: 0.2rem;
}
.sprite-icon_gonggao {
  background: url("../assets/image/duo.png");
  width: 0.49rem;
  height: 0.49rem;
  background-size: 2.53913043rem 2.3026087rem;
  background-position: -1rem 0.9rem;
}
.c_a0a0a0 {
  color: #a0a0a0;
}
.cont-head {
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  margin-top: 0.2rem;
  padding: 0 0.2rem;
}
.cont-left {
  width: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 0.3rem;
  padding: 0.6rem 0.2rem;
  color: #fff;
  background: #1a243f;
  border-radius: 4px;
}
.en-text {
  text-align: left;
  font-size: 0.37rem;
}
.left-text {
  padding-top: 0.22rem;
  color: #999;
  font-size: 0.35rem;
}
.icon {
  margin-left: 0.4rem;
  width: 1.29rem;
  height: 1.32rem;
}
.cont-right {
  width: 50%;
}
.huobin {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #1a243f;
  border-radius: 4px;
  color: #fff;
  font-size: 0.37rem;
}
.rightcion {
  width: 0.77rem;
  height: 0.65rem;
  margin-right: 0.2rem;
}
.menu-container {
  display: flex;
  justify-content: space-between;
  margin-top: 0.2rem;
  padding: 0 0.2rem;
}
.prize-news-wrap {
  padding-bottom: 50px;
  margin-top: 0.2rem;
}
.sub-title {
  display: flex;
  text-align: center;
  font-size: 14px;
  color: #afafaf;
  background: #0f1634;
  span {
    flex: 1;
    padding: 0.1rem 0 0.2rem;
  }
}
.prize-news {
  height: 150px;
}
.prize-marquee {
  height: 150px !important;
  font-size: 14px;
}
.vux-marquee {
  width: 100%;
  overflow: hidden;
  height: 300px;
}
.vux-marquee-box {
  padding: 0;
  margin: 0;
  width: 100%;
  height: auto;
}
.prize-marquee-item {
  height: 30px;
  line-height: 30px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  span {
    display: inline-block;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex: 1;
  }
  .name,
  .money {
    color: #b99318;
  }
  .type,
  .date {
    color: #fff;
  }
}
</style>
